import { dataGradeCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGradeCircleSolid = /*#__PURE__*/createIcon(dataGradeCircleSolid)
export default IconGradeCircleSolid
